import { Component, OnInit } from '@angular/core';
import { Authentication } from '../../services/authentication.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TitleService } from '../../services/title.service';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-not-logged-in',
  templateUrl: './not-logged-in.component.html',
  styleUrls: ['./not-logged-in.component.css'],
})
export class NotLoggedInComponent implements OnInit {
  constructor(
    private authService: Authentication,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
  }
  setTabTitle() {
    this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
  }
  ngOnInit(): void {
    this.setTabTitle();
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com';
  }
}
